var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57333 0.777778C1.6 1.12389 1.66667 1.46222 1.77333 1.785L1.24 2.25167C1.05778 1.785 0.942222 1.29111 0.902222 0.777778H1.57333ZM5.95556 5.45222C6.33333 5.54556 6.72 5.60389 7.11111 5.62722V6.20667C6.52444 6.17167 5.96 6.07056 5.42222 5.915L5.95556 5.45222ZM2 0H0.444444C0.2 0 0 0.175 0 0.388889C0 4.04056 3.38222 7 7.55556 7C7.8 7 8 6.825 8 6.61111V5.25389C8 5.04 7.8 4.865 7.55556 4.865C7.00444 4.865 6.46667 4.78722 5.96889 4.64333C5.92444 4.62778 5.87556 4.62389 5.83111 4.62389C5.71556 4.62389 5.60444 4.66278 5.51556 4.73667L4.53778 5.59222C3.28 5.02833 2.24889 4.13 1.60889 3.02944L2.58667 2.17389C2.71111 2.065 2.74667 1.91333 2.69778 1.77722C2.53333 1.34167 2.44444 0.875 2.44444 0.388889C2.44444 0.175 2.24444 0 2 0Z",
    fill: "#BFC3C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a7d31ffde4b4cd66f8004020283f9939.svg";
export { ForwardRef as ReactComponent };